import React, { useState, useEffect, useMemo, useRef } from 'react';
import './CityHub.css';
import { LoadingOverlay, resolveAsset } from '@/core/utils/common.utils';
import { usePanZoom } from '@/view/ui/common/PanZoom';

interface Building {
    id: string;
    src: string;
    name: string;
    x: number;
    y: number;
    w: number;
    h: number;
    hitPath: string;
}

const BUILDINGS_DATA: Building[] = [
    { 
      id: 'desyatynna', 
      src: '@assets/city/desyatynna.webp', 
      name: 'Десятинна церква', 
      x: 2265, y: 632, w: 1005, h: 836,
      hitPath: "m 461.56,778.25c -43.69,-12.68 -90.47,-0.38 -134.25,-14.44 -43.99,-1.88 -87.93,4.69 -130.74,-6.66 -42.92,0.44 -86.71,0.05 -126.59,-17.94 -30.12,-8.41 -1.95,-59.6 -9.2,-86.64 2.47,-32.46 -3.46,-66.57 -3.34,-97.37 20.15,-30.65 59.54,-34.34 85.45,-57.96 33.35,-19.88 18.54,-61.89 19.25,-93.23 -7.65,-47.64 32.93,-72.23 57.9,-104.96 10.92,-20.55 -19.77,-65.43 18,-43.73 -20.87,32.63 13.67,70.35 42.03,88.07 18.08,16.47 7.51,86.49 32.78,40.35 23.24,-39.53 -20.65,-88.29 11.37,-119.52 4.61,-50.93 55.63,-71.99 91.78,-96.33 14.54,-23.6 11.15,-55.99 17.24,-75.07 -10.97,-7.28 -34.93,-8.74 -9.91,-20.28 15.59,-2.22 15.48,-36.57 24.34,-8.4 -3.01,14.39 35.14,13.8 8.47,22.94 -25.64,15.11 2.11,63.17 14.5,84.2 39,15.76 68,45.97 95.3,77.34 22.63,2.26 -6.34,71.95 39.64,78.1 22.92,35.8 68.83,-17.37 68.48,-44.97 -15.31,-15.59 4.94,-53.13 11.91,-21.34 -16.86,40.56 19.08,56.37 42.47,79.63 20.77,32.22 13.97,70.92 14.23,106.72 16.36,32.36 72.81,-11.43 79.71,39.26 17.78,33.04 64.6,55.53 55.16,97.53 -23.63,37.73 30.56,67.3 59.32,81.42 27.35,18.82 -3.24,59.64 3.76,89.47 -27.3,27.91 -81.67,-0.09 -120.01,14.68 -40.39,5.72 -80.82,-0.51 -121.54,3 -34.49,12.79 -73.19,-6.72 -110.47,1.56 -41.89,10.15 -84.69,0.53 -127.05,4.56z"
    },
    { 
      id: 'dytynetz', 
      src: '@assets/city/dytynetz.webp', 
      name: 'Дитинець', 
      x: 314, y: 943, w: 1209, h: 628,
      hitPath: "M 261.31,577.53C 221.17,571.64 181.37,565.75 142.07,558.14 117.02,545.22 71.79,551.77 84.8,516.49 86.39,489.67 86.61,458.71 51.13,469 19.54,451.27 70.89,428.08 87.67,413.97 109.26,396.13 142.4,380.85 128.9,356.07 159.53,325.73 194.91,312.51 238.64,320.95 281.21,341.06 285.24,285.1 268,265.5c -53.94,1.58 17.86,-51.47 32.11,-70.64 31.05,-39.11 85.43,-19.26 128.31,-24.04 35.53,-16.82 82.26,-43.45 100.71,-80.15 -3.8,-15.08 13.36,-35.4 -8.82,-38.8 3.25,-6.01 20.21,-23.02 23.61,-6.28 28.1,1.14 -17.4,14.51 0.9,33.75 2.47,41.6 53.74,58.54 81.23,85.88 21.53,12.71 15.81,33.91 48.19,24.36 73.08,1.5 146.25,-1.88 219.24,-3.58 19.05,31.67 35.23,68.79 64.12,94.7 27.95,22.52 -47.36,33.66 5.75,31.73 62.06,-1.51 124.35,-0.27 186.26,1.47 37.62,25.5 27.35,60.07 23.81,98.7 -5.97,22.86 -29.62,46.09 -44.08,62.37 -45.98,9.5 -93.22,7.29 -139.41,3.55 -74.6,5.84 -150.02,8.04 -224.89,1.28C 732.85,472.8 693.69,491.92 666,479.18 650.03,467.9 615.82,485.58 600.06,467.02 570.17,478.16 506.11,434.18 498,473.48c 11.54,55.6 -77.02,22.81 -58.01,74.64 6.03,40.62 -67.28,20.58 -93.22,34.99 -28.17,6.9 -57.12,-3.59 -85.47,-5.58z"
    },
    { 
      id: 'golden_gates', 
      src: '@assets/city/golden_gates.webp', 
      name: 'Золоті Ворота', 
      x: 1162, y: 968, w: 932, h: 1205,
      hitPath: "m 502.5,1162.64c -38.18,-5.55 -76.46,-13.35 -117.36,-11.05 -48.4,-2.11 -97.82,-8.05 -145.81,-2.83 -22.85,13.92 -64.77,6.5 -57.22,-22.1 -21.85,-10.22 -33.84,12.51 -54.53,7.99 -27.3,-0.71 -54.76,0.43 -81.93,-2.2 1.7,-43.72 -15.29,-94.84 6.87,-134.4 19.99,-37.5 45.51,-73.76 49.66,-116.32 1.51,-40.46 7.3,-88.23 60.86,-70.47 56.15,8.86 20.4,-73 30.07,-108.25 -1.11,-34.09 1.81,-69.36 -1.8,-102.72 -17.38,-33.02 -0.7,-77.71 -8.92,-115.08 27.26,-31.09 107.57,9.32 114.61,-56.46 26,-22.56 29.23,-50.37 29.25,-84.41 15.34,-68.04 86.95,-94.96 139.45,-129.63 30.55,-27.58 31.37,-66.14 35.93,-106.29 6.31,-25.29 -50.47,1.12 -24.73,-34.16 38.82,20.26 7.3,-53.2 41.19,-28.65 3.53,18.49 -0.46,34.76 23.6,29.65 19.11,30.19 -38.67,10.04 -19.16,45.61 6.82,44.87 21.88,90.56 66.97,114.28 45.44,24.12 94.68,55.98 105.12,110.46 -10.33,57.45 43.29,65.82 87.7,63.16 13.9,26.59 2.33,61.39 29.86,74.97 15.28,15.23 53.12,6.35 71.79,21 3.41,29.45 3.03,59.16 4.18,88.75 -21.17,15.51 9.02,60.26 -9.64,70.98 -24.18,-0.09 -48.35,-0.19 -72.53,-0.28 0.17,47.43 0.34,94.87 0.51,142.3 17.29,1.84 37.1,-2.11 52.95,3.03 15.94,10.69 19.22,26.95 18.17,45.12 5.75,48.54 6.66,97.24 6.46,146.26 -28.73,47.32 -62.7,91.46 -88.68,140.48 -32.68,-0.3 -92.5,5.94 -111.02,-5.38 -23.96,-13.03 -64.26,-4.86 -95.24,-7.81 -32.51,-9.6 -45.02,35.05 -75.55,34.89z"
    },
    { id: 
      'sophia', 
      src: '@assets/city/sophia_cathedral.webp', 
      name: 'Софія Київська', 
      x: 1110, y: 262, w: 1316, h: 1099,
      hitPath: "m 765.2,1035.76c -44.11,2.11 -47.47,-64.87 -92.1,-74.89 -38.74,-23.67 -102.35,-55.31 -91.23,-109.83 -18.03,-28.48 -9.13,-54.55 17.17,-58.97 -6.61,-18.97 -39.97,-0.78 -25.68,-36.07 -25.99,-26.33 -13.83,17.71 -25.2,28.24 -32.12,-13.06 -22.41,32.38 7.24,18.25 0.05,46.75 1.21,104.89 -49.62,131.31 -45.97,25.11 -96.67,50.95 -118.79,101.42 -21.49,-41.76 -59.91,-45.76 -102.59,-38.9 -45.59,-5.95 -98.78,5.65 -140.27,-4.25 56.78,-21.48 -37.26,-67.57 -38.26,-107.23 -8.88,-22.47 -37.81,-9.86 -27.41,-44.4 3.82,-31.17 -0.09,-57.09 -20.52,-71.58 34.02,-25.09 51.31,-48.07 62.43,-80.52 33.37,0.11 12.09,-42.16 17.25,-64.14 -32.51,-21.98 35.31,-35.96 9.15,-67.11 4.39,-49.99 70.17,-67.38 73.61,-115.98 -6.51,-16.42 12.2,-29.84 -17.48,-24.96 6.09,-18.91 18.97,-16.83 24.54,-36.04 10.56,22 35.82,27.21 6.79,41.88 -12.08,32.06 58.56,115.08 42.16,43.76 2.39,-60.2 78.39,-76.96 85.86,-135.42 -13.52,-18.02 11.33,-43.04 -19.93,-43.14 15.8,-10.58 18.18,-15.46 26.47,-32.94 15.84,9.39 -6.28,31.88 21.83,24.4 0.05,14.33 -31.42,17.87 -8.37,43.42 -13.55,47.07 60.14,100.37 77.8,31.05 12.27,-26.97 -19.58,-47.75 10.99,-54.61 22.13,13.14 -16.12,52.34 24.97,77.61 28.69,9.72 -1.13,-63.09 24.83,-80.05 22.24,-63.43 107.19,-65.47 131.59,-125.96 12.46,-23.85 -14.35,-42.44 6.06,-52.99 12.68,-29.86 -52.49,-6.5 -13.72,-32.58 22.47,10.78 6.61,-48.95 28.98,-16.03 -15.61,26.05 44.47,6.32 13.52,32.32 -39.35,-0.24 3.02,43.73 -10.76,59.44 15.37,44.81 58.76,63 97.33,84.39 50.22,28.7 46.94,100.22 61.68,136.67 36.09,43.56 97.55,-36.04 82.53,-70.06 2.83,-16.3 10.96,-32.07 -11.32,-28.95 -2.48,-17.42 25.96,-9.73 21.64,-34.7 17.23,2.25 -0.22,30.55 24.22,22.14 -0.01,14.48 -29.91,18.37 -9.88,44.68 -11.94,44.66 49.68,70.24 69.81,103.38 19.5,31.63 1.55,120.58 58.12,64.17 21.86,-22.27 31.94,-66.75 2.67,-71.77 18.46,-9.48 15.94,-12.17 25.34,-30.85 1.55,21.74 45.44,33.61 6,44.36 -6.05,42.75 37.69,72.01 65.56,102.65 19.94,29.92 -0.82,65.03 31.75,86.21 -28.13,36.93 -12.65,80.86 21.34,105.37 21.93,21.95 46.3,38.26 23.93,65.02 -4.33,21.95 5.92,53.32 -3.89,71.52 -64.8,6.77 -130.16,-5.5 -194.67,-1.84 -36.68,-7.93 -56.01,23.15 -77.31,47.82 -15.86,25.72 -33.98,16.27 -53.05,25.76 3.05,25.65 -60.34,67.07 -24.11,75.28 26.49,2.3 3.76,49.51 -25.29,29.22 -31.91,-3.58 -61.47,11.25 -93.45,5.62l -10.3,-0.58z"
    },
];

const BACKGROUND_SRC = '@assets/city/kyiv.webp';
const ORIGINAL_WIDTH = 4096;
const ORIGINAL_HEIGHT = 2728;
const MIN_SCALE = 1;
const MAX_SCALE = 2;

export const CityHub: React.FC = () => {
    const [progress, setProgress] = useState(0);
    const [isReady, setIsReady] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const mapRef = useRef<HTMLDivElement>(null);

    // стан трансформації — тільки ref, без setState щоб не тригерити рендер
    // const transform = useRef({ x: 0, y: 0, scale: 1 });
    const { transform } = usePanZoom(containerRef, mapRef, {
      minScale: MIN_SCALE,
      maxScale: MAX_SCALE,
      enabled: isReady,
      onTap: (e) => {
          // клік по будівлі обробляється тут або через event bubbling
      }
  });

    const applyTransform = () => {
        if (!mapRef.current) return;
        const { x, y, scale } = transform.current;
        mapRef.current.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    };

    const setLoaded =  async() => {
      await LoadingOverlay.hide();
      setIsReady(true);
    }

    const allUrls = useMemo(() => [
        resolveAsset(BACKGROUND_SRC),
        ...BUILDINGS_DATA.map(b => resolveAsset(b.src))
    ], []);

    useEffect(() => {
        let loaded = 0;
        allUrls.forEach(url => {
            const img = new Image();
            img.src = url;
            img.onload = img.onerror = () => {
                loaded++;
                if (loaded === allUrls.length) setTimeout(() => {setLoaded()}, 200);
            };
        });
    }, [allUrls]);

    useEffect(() => {
      if (mapRef.current) mapRef.current.classList.add('is-animating');

      if (!isReady || !containerRef.current || !mapRef.current) return;
      
      const vw = containerRef.current.offsetWidth;
      const vh = containerRef.current.offsetHeight;
      const mw = mapRef.current.offsetWidth;
      const mh = mapRef.current.offsetHeight;

      const targetScale = Math.max(vw / mw, vh / mh) * 1.1;
      const x = (vw - mw * targetScale) / 2;
      const y = (vh - mh * targetScale) / 3;

      // відразу центруємо з меншим масштабом без анімації
      transform.current = { x, y, scale: MIN_SCALE };
      applyTransform();

      // setTimeout(() => {
          if (!mapRef.current) return;
          mapRef.current.style.transition = 'transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          transform.current = { x, y, scale: targetScale };
          applyTransform();

          setTimeout(() => {
              if (mapRef.current) {
                mapRef.current.style.transition = '';
                mapRef.current.classList.remove('is-animating');
              }
          }, 1000);
      // }, 50);
    }, [isReady]);

  
    if (!isReady) {
        return null;
    }

    return (
        <div className="hub-viewport" ref={containerRef}>
            <div ref={mapRef} className="hub-map-container" style={{ transformOrigin: '0 0' }}>
                <img src={resolveAsset(BACKGROUND_SRC)} className="hub-bg-layer" draggable="false" />
                {BUILDINGS_DATA.map(building => (
                    <div
                        key={building.id}
                        className="hub-building-node"
                        style={{
                            left: `${(building.x / ORIGINAL_WIDTH) * 100}%`,
                            top: `${(building.y / ORIGINAL_HEIGHT) * 100}%`,
                            width: `${(building.w / ORIGINAL_WIDTH) * 100}%`,
                            height: `${(building.h / ORIGINAL_HEIGHT) * 100}%`,
                        }}
                        onClick={() => console.log(`Клік по: ${building.name}`)}
                    >
                        <img src={resolveAsset(building.src)} className="hub-building-sprite" draggable="false" />
                        <svg
                            width="100%"
                            height="100%"
                            style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
                            viewBox={`0 0 ${building.w} ${building.h}`}
                        >
                            <path
                                d={building.hitPath}
                                fill="transparent"
                            />
                        </svg>
                    </div>
                ))}
            </div>
        </div>
    );
};